import { ShapeTypeProps } from '.'

const Circle = ({ color, ...props }: ShapeTypeProps) => {
  return (
    <svg width="327" height="168" viewBox="0 0 327 168" fill="none" {...props}>
      <path
        d="M127 168C237.457 168 327 78.4569 327 -32C327 -142.457 237.457 -232 127 -232C16.5431 -232 -73 -142.457 -73 -32C-73 78.4569 16.5431 168 127 168Z"
        fill={color}
      />
    </svg>
  )
}
export { Circle }
